import Meta from '@/components/common/Meta'

import CollegeDormMovingPage from '@/v2/components/pages/landing-pages/college-dorm-moving-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/college-dorm-moving-page'

interface CollegeDormMovingPageProps {}

const Page: React.FC<CollegeDormMovingPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.college_dorm_moving.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.college_dorm_moving?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.college_dorm_moving?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CollegeDormMovingPage />
    </>
  )
}

export default Page
